import angular from 'angular';
import { downgradedModule } from '../../../ng-app/main';

import Camera from './CameraComponent';
import CameraPlayer from './CameraPlayerComponent';
import CameraControls from './CameraControlsComponent';
import CameraService from './CameraService';
import Overlay from './CameraControlsOverlayComponent';
import settingsControls from './SettingsControlsComponent';
import Component from './CameraPanelComponent';

// Submodules
import PTZ from './modalcomponents/ptz';
import ZoneSelection from './modalcomponents/zoneSelection';

// Modal
import CamAudio from './modalcomponents/CamAudioComponent';
import CameraStream from './modalcomponents/StreamComponent';
import CellGridMotionComponent from './modalcomponents/CellGridMotionComponent';
import IR from './modalcomponents/irComponent';
import LiveFeed from './modalcomponents/CameraAudioLiveFeedComponent';
import PTZControls from './modalcomponents/PTZControlsComponent';
import PTZControlsService from './modalcomponents/PTZControlsService';
import PTZModal from './PTZModalComponent'; // TODO: Why isn't this in the modal directory?
import Recording from './modalcomponents/RecordingsComponent';
import SettingsModal from './CameraSettingsModalComponent';
import ZoneModal from './modalcomponents/ZoneComponent';
import ZoomFocus from './modalcomponents/ZoomFocusComponent';

export default angular
  .module('petroCloud.dashboard.cameraPanel', [
    downgradedModule,
    PTZ,
    ZoneSelection
  ])
  .component(Camera.name, Camera)
  .component(CameraPlayer.name, CameraPlayer)
  .component(CameraControls.name, CameraControls)
  .component(Overlay.name, Overlay)
  .component(settingsControls.name, settingsControls)
  .component(Component.name, Component)
  .component(CamAudio.name, CamAudio)
  .component(IR.name, IR)
  .component(LiveFeed.name, LiveFeed)
  .component(PTZControls.name, PTZControls)
  .component(PTZModal.name, PTZModal)
  .component(Recording.name, Recording)
  .component(SettingsModal.name, SettingsModal)
  .component(CameraStream.name, CameraStream)
  .component(ZoneModal.name, ZoneModal)
  .component(ZoomFocus.name, ZoomFocus)
  .component(CellGridMotionComponent.name, CellGridMotionComponent)
  .service('CameraService', CameraService)
  .service('PTZControlsService', PTZControlsService)
  .name;
